import { AuthService } from './../../services/auth.service';
import { NotificationService } from './../../services/notifications.service';
import { Actions, ofType } from '@ngrx/effects';
import * as AuthActions from './../../store/actions/auth.actions';
import { Component, OnInit, ViewChild, ElementRef, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
// import * as AppActions from './../../store/actions';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
  private successSubcription: Subscription;
  private errorSubcription: Subscription;
  public hide: boolean;
  public signupForm: FormGroup;
  public signupProcess = false;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private notificationService: NotificationService,
    private storeActions$: Actions,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SignupComponent>,
    ) {
      let email = '';
      let password = '';

      // Creación del formulario que se mostrará en el template
      this.signupForm = fb.group({
        email: new FormControl(email, [Validators.required, Validators.email]),
        password: new FormControl(password, [Validators.required, Validators.minLength(6)])
      });
    }
  ngOnInit() {
    // Nos subscribimos al canal del store que nos informa de un login correcto
    this.successSubcription = this.storeActions$.pipe(
      ofType(AuthActions.SIGNIN_SUCCESS),
    ).subscribe(() => {
      this.signupProcess = false;
      this.close();
    });

    this.errorSubcription = this.storeActions$.pipe(
      ofType(AuthActions.SIGNIN_ERROR),
      map((action: AuthActions.SigninError) => action.payload.error)
    ).subscribe((error) => {
      this.signupProcess = false;
      // TODO realizar diferentes acciones en función del errror.code: 'auth/user-not-found'
      this.notificationService.error(error.message);
    });
  }
  doSignup() {
    if (!this.signupProcess) {
      this.signupProcess = true;
      this.authService.Signup(this.signupForm.value);
    }
  }

  close() {
    this.dialogRef.close();
  }
  ngOnDestroy() {
    this.successSubcription.unsubscribe();
    this.errorSubcription.unsubscribe();
  }

}
